import ROLE from "enums/ROLE_NAME";
import { RoleHierarchy } from "types/Role";

export function hasRole(requiredRole: ROLE, userRole: ROLE) {
  return requiredRole === userRole;
}

export function hasSuperAdminRole(role: ROLE) {
  return role === ROLE.SUPER_ADMIN || role === ROLE.SUPER_DUPER_ADMIN;
}

export function hasViewerRole(role: ROLE) {
  return role === ROLE.VIEWER;
}

export function getHighestRoleHierarchyIndex(role: ROLE) {
  const index = RoleHierarchy.findIndex((roleLevel) => role === roleLevel);
  if (index !== -1) {
    return index;
  }
  return RoleHierarchy.length - 1;
}
